import { GET_REQUIREMENTS_TAGS } from 'actions/actionTypes';
import { getRequirementsTags } from 'api/requirementsTags';
import {
  getRequirementsTagsSuccess,
  getRequirementsTagsFailure,
} from 'actions';
import { apiPromise } from './apiPromise';

export const requirementsTags = store => next => (action) => {
  switch (action.type) {
    case GET_REQUIREMENTS_TAGS.REQUEST: {
      next(action);
      return apiPromise(
        store,
        action,
        getRequirementsTags,
        [],
        getRequirementsTagsSuccess,
        getRequirementsTagsFailure
      );
    }
    default:
      next(action);
      return Promise.resolve();
  }
};

export default requirementsTags;
